import { createReducer } from '@reduxjs/toolkit';

import { CategoryDto } from '../models/dto/category-dto';
import { categoriesLoaded } from './configuration-actions';

export interface CategoriesState {
    categoriesById: Record<number, CategoryDto>;
    categoriesByParentId: Record<number, CategoryDto[]>;
}

const initialState: CategoriesState = {
    categoriesById: {},
    categoriesByParentId: {},
};

export const categoriesReducer = createReducer(initialState, builder => {
    builder.addCase(categoriesLoaded, (state, action) => {
        action.payload.forEach(category => {
            if (!state.categoriesByParentId[category.parentId ?? -1]) {
                state.categoriesByParentId[category.parentId ?? -1] = [];
            }
            if (!state.categoriesByParentId[category.parentId ?? -1]?.some(c => c.id === category.id)) {
                state.categoriesByParentId[category.parentId ?? -1].push(category);
            }
            state.categoriesById[category.id] = category;
        });
    });
});
